(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AppointmentRecurrenceUpdateService', ['$uibModal', '$q', RecurrenceUpdateServiceFn]);

    // global recurrence update service 
    function RecurrenceUpdateServiceFn($uibModal, $q) {

        var service = {
            getUpdateMethod: getUpdateMethod
        };

        function getUpdateMethod() {
            // make deferred ref
            var deferred = $q.defer();

            // open modal
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/agenda/templates/agenda-appointment-recurrence-update-modal.template.html',
                controller: 'AgendaAppointmentRecurrenceUpdateController',
                controllerAs: 'vm',
                size: 'md'
            });

            // when modal is closed
            modalInstance.result.then(function (method) {
                return deferred.resolve(method);
            }, function () {
                // dismissed
                return deferred.reject(null);
            });

            return deferred.promise;
        }

        return service;
    }
})();